// src/constants/nav.js
export const NAV_CATALOG = {
  dashboard: { label: "Dashboard", to: "/futbolito/dashboard" },
  colaboradores: { label: "Colaboradores", to: "/futbolito/colaboradores" },
  representantes: { label: "Representantes", to: "/futbolito/representantes" },
  deportistas: { label: "Deportistas", to: "/futbolito/deportistas" },
  grupos: { label: "Grupos", to: "/futbolito/grupos" },
  eventos: { label: "Eventos", to: "/futbolito/eventos" },
  asistencias: { label: "Asistencias", to: "/futbolito/asistencias" },
  notificaciones: { label: "Notificaciones", to: "/futbolito/notificaciones" },
  roles: { label: "Roles", to: "/futbolito/roles" },
  pagos: { label: "Pagos", to: "/futbolito/pagos" },
};

export const NAV_ORDER = Object.keys(NAV_CATALOG);

export function pickFirstAllowedRoute(readPerms) {
  const perms = readPerms || {};
  for (const key of NAV_ORDER) {
    if (perms[key]) return NAV_CATALOG[key].to;
  }
  return null;
}
